import React from 'react'
import Styled from 'styled-components'

import Icon from 'components/Icon'

const Container = Styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default props => (
  <Container>
    <Icon
      liga="close"
      onClick={props.onClose}
    />
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/DialogClose/index.js